import React from 'react';
import Routes from './routes/Router';
import "./App.css"

const App = () => {
  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
}

export default App;
